import { Box, Dialog, List, ListItem, Typography } from "flux";
import { AppError } from "@adora/shared/types/result";
import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
interface ErrorDialogProps extends BaseDialogProps {
  error: AppError;
  title: string;
}

export default function ErrorDialog(props: ErrorDialogProps) {
  const { title, open, onClose, error } = props;

  const renderError = () => {
    switch (error.tag) {
      case "traceError": {
        return <Typography variant="body1">{error.message}</Typography>;
      }
      case "validationError": {
        return (
          <Box>
            <Typography variant="body1">{error.message}</Typography>
            <List>
              {error.errors.map((e, index) => (
                <ListItem key={index}>{e}</ListItem>
              ))}
            </List>
          </Box>
        );
      }
      case "valueError": {
        return (
          <Box>
            <Typography variant="body1">{error.message}</Typography>
            <Typography variant="body1">{error.value}</Typography>
          </Box>
        );
      }
      case "unknownError": {
        return <Typography variant="body1">{error.message}</Typography>;
      }
      default: {
        return <Typography variant="body1">{error.message}</Typography>;
      }
    }
  };

  return (
    <Dialog
      size="md"
      title={title}
      open={open}
      onClose={onClose}
      primaryButtonText="Ok"
      dataDogIdentifier="error dialog"
    >
      {renderError()}
    </Dialog>
  );
}
